import { render } from "./ButtonCancel.vue?vue&type=template&id=1003351e&scoped=true"
import script from "./ButtonCancel.vue?vue&type=script&lang=js"
export * from "./ButtonCancel.vue?vue&type=script&lang=js"

import "./ButtonCancel.vue?vue&type=style&index=0&id=1003351e&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\demo\\codebasezoom\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1003351e"]])

export default __exports__